// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__20i6z","errors":"Errors_errors__1mPZA"};